<template>
  <div>
    <a-modal
      title="电子围栏"
      style="top: 20px;"
      :width="800"
      v-model="visible"
      :confirmLoading="confirmLoading"
      @ok="handleSubmit"
      :footer="false"
      :maskClosable="false"
    >
      <div id="container"></div>
      <a-row :gutter="24" style="height: 30px;margin-top:10px">
        <a-col :span="16"></a-col>
        <a-col :span="8">
              <span style="display: flex;justify-content: center;">
                <a-button :disabled="!editEnable" class="twobtn" type="primary" @click="rectangleEditor.open()">开始编辑</a-button>
                <a-button :disabled="!editEnable" class="twobtn" style="margin-left: 35px" @click="rectangleEditor.close()">结束编辑</a-button>
              </span>
        </a-col>
      </a-row>
    </a-modal>
  </div>

</template>


<script>
import  AMap from 'AMap'
import  {Pointinsert,PointinsertMember} from '@/api/master/TeamManagement'
import { checkPermission } from '@/utils/permissions'

    export default {
        name: "Tomap",
      data(){
          return{
            rectangleEditor: null,
            visible:false,
            confirmLoading: false,
            southWest:'',
            northEast:'',
            lat:'',
            lon:'',
            editEnable:checkPermission('master:teamList:memberList:edit'),
          }
      },
     mounted(){
       this.loadmap();  //加载地图和相关组件
      },
      methods:{
         async loadmap(data,code){
              //var southWest,northEast,lat,lon
            if(data.geometry.coordinates[0].length<4){
             this.lat=data.geometry.coordinates[0][0]
              this.lon=data.geometry.coordinates[0][1]
              this.southWest = new AMap.LngLat( this.lon,this.lat)
              this.northEast = new AMap.LngLat(this.lon+0.002,this.lat+0.002)
            }else{
              this.lat=data.geometry.coordinates[0][0][1]
              this.lon=data.geometry.coordinates[0][0][0]
              this.southWest = new AMap.LngLat(data.geometry.coordinates[0][0][0], data.geometry.coordinates[0][0][1])
              this.northEast = new AMap.LngLat(data.geometry.coordinates[0][2][0], data.geometry.coordinates[0][2][1])
            }

            var map = new AMap.Map('container', {
              center: [this.lon,this.lat],
              zoom: 13
            });
            var bounds = new AMap.Bounds(this.southWest, this.northEast)

            var rectangle = new AMap.Rectangle({
              bounds: bounds,
              strokeColor:'red',
              strokeWeight: 6,
              strokeOpacity:0.5,
              strokeDasharray: [30,10],
              // strokeStyle还支持 solid
              strokeStyle: 'dashed',
              fillColor:'blue',
              fillOpacity:0.5,
              cursor:'pointer',
              zIndex:50,
            })

            rectangle.setMap(map)
            // 缩放地图到合适的视野级别
            map.setFitView([ rectangle ])

            this.rectangleEditor = new AMap.RectangleEditor(map, rectangle)

            this.rectangleEditor.on('adjust', function(event) {
              console.log(event,'开始')
            })

            this.rectangleEditor.on('end', function(event) {

              var arr = new Array();

              for(let i=0;i<event.target.Ce.path.length;i++){
                arr[i]=event.target.Ce.path[i].lng+' '+event.target.Ce.path[i].lat
                // arr.push({
                //   lat:event.target.De.path[i].lat,
                //   lng:event.target.De.path[i].lng,
                // })
              }
              arr[4]=arr[0]
              console.log(arr)
              if(code==0){//0为团队1为团员
                Pointinsert({
                  teamId:data.properties.nameId,
                  areaList:arr
                }).then(res=>{
                  //console.log(res)
                })
              }else if(code==1){
                PointinsertMember({
                  teamId:data.properties.nameId,
                  areaList:arr
                }).then(res=>{
                  //console.log(res)
                })
              }

              // event.target 即为编辑后的矩形对象
            })

          },
          add(data,code){
            let that=this
            this.$nextTick(() => {
              this.visible=true
            })
            setTimeout(function(){

              that.loadmap(data,code);
            },500)

          },
      },
    }
</script>

<style scoped>

  #container{
    width: 760px;
    height:500px;
  }
</style>